import store from "@/store";
import router from "@/router"
import {EventBus} from "@/utils/eventBus";


class Tools {
    /**
     * 获取当前时间戳，秒级
     * @constructor
     */
    getDateTime() {
        return Math.floor(new Date().getTime() / 1000);
    }

    /**
     * 获取token
     * @returns {string}
     */
    getToken() {
        return localStorage.getItem("token");
    }

    /**
     * 设置token
     * @param token
     */
    setToken(token) {
        EventBus.$emit("wsSendMsg", {
            type: "login",
            platform: 7,
            token: token
        })
        localStorage.setItem("token", token);
    }

    /**
     * 删除token
     */
    delToken() {
        localStorage.removeItem("token");
    }

    /**
     * 科目符号切割
     * @returns {boolean}
     */
    splitSubject(str) {
        let str_tem = str.split(":")[1];
        if (str_tem === 'EXAM_SUBJECT_2' || str_tem === 'EXAM_SUBJECT_3') {
            return true;
        } else {
            return false;
        }
    }

    /**
     * 车型科目回显
     */
    cartypesubjectecho(carlist = []) {
        // 车型合并
        const mergecar = [...carlist.driver, ...carlist.qualification]
        // 用户信息
        const userinfo = store.getters['user/userInfo'];
        if (!userinfo) {
            return {}
        }
        // 当前的车型
        const current_car_type = mergecar.find(item => item.id === userinfo.car_type_id) || {};
        current_car_type.car_subject = current_car_type.car_subject || []
        // 当前选择科目的下标
        const current_tab_list_index = current_car_type.car_subject.find(item => item.id === userinfo.car_subject_id)
        // 当前的tab
        const current_tab_list = current_car_type.car_subject
        console.log("当前的头部回显数据", {
            current_car_type,
            current_tab_list_index,
            current_tab_list
        })
        return {
            current_car_type,
            current_tab_list_index,
            current_tab_list
        }
    }

    /**
     * 科目判断
     */
    splitStr(str, suffix) {
        const signs = str.split(":")[1]
        return signs === `EXAM_SUBJECT_${suffix}`
    }

    /**
     * 是否资格证判断
     */
    is_qualification() {
        try {
            const driver_arr = store.getters['user/carList']?.driver || []
            const car_type_id = store.getters['user/userInfo'].car_type_id
            const exists = driver_arr.some(item => item.id === car_type_id);
            return exists
        } catch (e) {
            return null
        }

    }

    /**
     * 退出登录清空信息
     */
    logout() {
        this.delToken()
        store.dispatch('user/logout')

        if (window.location.hash == '#/') {
            window.location.reload()
        } else {
            router.replace({
                path: '/'
            }, () => {
                window.location.reload()
            })
        }


    }

    getOrigin() {
        return window.location.protocol + '//' + window.location.host;
    }


}

export default new Tools();
